import { render, staticRenderFns } from "./print-positions-manager-v2.vue?vue&type=template&id=b6d0f9ac"
import script from "./print-positions-manager-v2.vue?vue&type=script&lang=ts"
export * from "./print-positions-manager-v2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports